import * as React from "react";
import { forwardRef } from "react";
const SvgUseTemplate = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.16732 10L15.834 10", stroke: "#2196F3", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.0007 4.16671L15.834 10L10.0007 15.8334", stroke: "#2196F3", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgUseTemplate);
export { ForwardRef as ReactComponent };
